

exports.__esModule = true;
exports["default"] = void 0;
var _index = require("squid/index");
var _directive = _interopRequireDefault(require("./directive"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var _default = exports["default"] = _index.$Route.extend('$xoConfirmUpopRoute', {
  path: 'confirmUpop',
  directive: _directive["default"],
  titleContent: 'confirmUpop.confirm',
  trackingData: {
    fptiState: 'confirm_upop'
  },
  query: ['fromLoginOverlay'],
  loginRequired: true,
  pageOnOverlay: true,
  children: []
});
_index.$Route;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ../node_modules/xo-wallet-components/src/confirm-upop/route.js
// module id = ../node_modules/xo-wallet-components/src/confirm-upop/route.js
// module chunks = 0